export enum UsageType {
  ANY = 'ANY',
  HANA_INSTANCE = 'HANA_INSTANCE'
}
